import { FilterOperators } from '@va/types/filters';
import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

export type ModuleAppliedFilter = {
  id: string;
  values: unknown[];
  operator?: FilterOperators;
  targetReportBlockIds?: string[];
};

const ModuleFiltersContext = createContext<ModuleAppliedFilter[]>([]);

export const ModuleFiltersProvider: React.FC<PropsWithChildren<{ value: ModuleAppliedFilter[] }>> = ({
  children,
  value,
}) => {
  const memoizedValue = useMemo(() => value ?? [], [value]);

  return <ModuleFiltersContext.Provider value={memoizedValue}>{children}</ModuleFiltersContext.Provider>;
};

export const useModuleFilters = () => useContext(ModuleFiltersContext);
